export default {

    public:{
        endLive:'endLive',
        endLiveAttendee:'endLiveAttendee',
    }
};
